import './portfolio-mockup-item.scss';
import EmptyPhoneImage from '@/assets/images/common/phone-mock.webp';
export default function PortfolioMockupItem({
	children,
	zIndexAdd
}: {
	children: React.ReactNode;
	zIndexAdd?: boolean;
}) {
	return (
		<div className="portfolio-mockup-item-wrapper">
			<img
				src={EmptyPhoneImage}
				alt="phone-mockup"
				className={`phone-mockup-screen ${
					zIndexAdd ? `z-index-add` : ''
				}`}
			/>
			<div className="phone-mockup-inner">{children}</div>
		</div>
	);
}
